import Vue from 'vue'
import Store from "@/store/index.js";
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue';
import Recuperar from '@/views/RecuperarContrasenia.vue';
import Main from '@/views/Main.vue';
import axios from "axios";

// import Principal from '@/views/Principal.vue';
import Index from "@/components/pages/main/Index.vue";
import MetodosGenrales from '@/utils/metodosgenerales.vue.js';

/* ERROR */
import NotAuthorized from '@/views/error/NotAuthorized.vue';
import PageNotFound from '@/views/error/PageNotFound.vue';


/* Operacion */
import Operacion from "@/components/pages/operacion/Operacion.vue";
import Tablero from "@/components/pages/operacion/tablero/Main.vue";
import Seguimiento from "@/components/pages/operacion/Seguimiento.vue";

/* Busqueda */
import BusquedaAvanzada from "@/components/pages/busqueda/BusquedaAvanzada.vue";
import busquedageneral from "@/components/pages/busqueda/BusquedaGeneral.vue"


/*Asistencia Juridica */
import AsistenciaJur from "@/components/pages/detalleReporte/AsisJuridica/Reporte.vue";
import ReporteDetalleAJ from "@/components/pages/detalleReporte/AsisJuridica/DetalleReporte.vue"
import Orales from "@/components/pages/detalleReporte/AsisJuridica/JuiciosOrales.vue"
import AverPrevia from "@/components/pages/detalleReporte/AsisJuridica/AverPrevia.vue"
import CivicoCivil from "@/components/pages/detalleReporte/AsisJuridica/CivicoCivil.vue"

/*Robo*/
import AsistenciaRobo from "@/components/pages/detalleReporte/robo/Reporte.vue";
import ReporteDetalleRobo from "@/components/pages/detalleReporte/robo/DetalleReporte.vue"
import AverPrevLibVeh from "@/components/pages/detalleReporte/robo/AverPrevLibVeh.vue"
import RoboAverPrev from "@/components/pages/detalleReporte/robo/AverPrev.vue"

/*RLV*/
import AsistenciaRLV from "@/components/pages/detalleReporte/RLV/Reporte.vue";
import ReporteDetalleRLV from "@/components/pages/detalleReporte/RLV/DetalleReporte.vue"
import AverPrevRLV1 from "@/components/pages/detalleReporte/RLV/AvePrev1.vue"
import AverPrevRLV2 from "@/components/pages/detalleReporte/RLV/AvePrev2.vue"
import AverPrevRLV3 from "@/components/pages/detalleReporte/RLV/AvePrev3.vue"
import AverPrevRLV4 from "@/components/pages/detalleReporte/RLV/AvePrev4.vue"
import AverPrevRLV5 from "@/components/pages/detalleReporte/RLV/AvePrev5.vue"
import AverPrevRLV6 from "@/components/pages/detalleReporte/RLV/AvePrev6.vue"

/* RCM */
import AsistenciaRCM from "@/components/pages/detalleReporte/RCM/Reporte.vue";
import ReporteDetalleRCM from "@/components/pages/detalleReporte/RCM/DetalleReporte.vue"

import Perfil from "@/components/pages/main/PerfilUsuario.vue";

/*Configuracion*/
import Configuracion from "@/components/pages/configuracion/Configuracion.vue"

/*Bitacora*/
import Bitacora from "@/components/pages/bitacora/Main.vue"

/*Estadisticas*/
import Estadistica from "@/components/pages/estadisticas/Main.vue";

/* Viales */
import Viales from "@/components/pages/Viales/Busqueda.vue";
/* Reporte Vial*/
import AsistenciaVial from "@/components/pages/detalleReporte/ReporteVial/Reporte.vue";
import ReporteDetalleVial from "@/components/pages/detalleReporte/ReporteVial/DetalleReporte.vue"

/*Documentos */
import Documentos from '@/components/pages/documentos/Main.vue';

Vue.use(VueRouter)
const domain = Store.state.domain;
const permisos = Store.state.permission;

function verficarPermiso(to, from, next, permiso) {
    MetodosGenrales.verificarPermisoSolo(domain.domainNameForApi, "VerificarPermiso", permiso).then(response => {
        if (response.data.length > 0) {
            next()
            var url = window.location.origin + window.location.pathname;
            MetodosGenrales.registrarPaginaVisitada(to.matched[1].name, to.name, url, domain.domainNameForApi);
        } else {
            next({ name: 'noautorizado' })
        }
    });
}

const routes = [

    {
        path: `${domain.domainName}/login`,
        name: "login",
        component: Login,
    },
    {
        path: `${domain.domainName}/`,
        component: Main,
        beforeEnter: (to, from, next) => {
            verficarPermiso(to, from, next, permisos.global);
        },
        redirect: `${domain.domainName}/login`,
        children: [
            {
                path: `${domain.domainName}/index`,
                name: "index",
                component: Index,
                beforeEnter: async (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global, 0, 0);
                }
            },
            {
                path: `${domain.domainName}/operacion`,
                name: "operacion",
                component: Operacion,
                children: [
                    {
                        path: `${domain.domainName}/operacion/tablero`,
                        name: "tablero",
                        component: Tablero,
                        beforeEnter: (to, from, next) => {
                            verficarPermiso(to, from, next, permisos.single.tablero);
                        }
                    },
                    {
                        path: `${domain.domainName}/operacion/seguimiento`,
                        name: "seguimiento",
                        component: Seguimiento,
                        beforeEnter: (to, from, next) => {
                            verficarPermiso(to, from, next, permisos.single.tablero);
                        }
                    },
                ]
            },
            {
                path: `${domain.domainName}/AsistenciaJuridica/Reporte/`,
                name: "asistenciaJur",
                component: AsistenciaJur,
                children: [
                    {
                        path: `${domain.domainName}/AsistenciaJuridica/Reporte/ReporteDetalle`,
                        name: "ReporteDetalleAJ",
                        component: ReporteDetalleAJ,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaJuridica/Reporte/JuiciosOrales`,
                        name: "OralesAJ",
                        component: Orales,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaJuridica/Reporte/AverPrevia`,
                        name: "AverPreviaAJ",
                        component: AverPrevia,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaJuridica/Reporte/CivicoCivil`,
                        name: "CivicoAJ",
                        component: CivicoCivil,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaJuridica/Reporte/Documentos/`,
                        name: "documentosAJ",
                        component: Documentos,
                    },
                ]
            },
            {
                path: `${domain.domainName}/AsistenciaRobo/Reporte/`,
                name: "asistenciaRobo",
                component: AsistenciaRobo,
                children: [
                    {
                        path: `${domain.domainName}/AsistenciaRobo/Reporte/ReporteDetalle`,
                        name: "ReporteDetalleRobo",
                        component: ReporteDetalleRobo,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRobo/Reporte/AverPrevLibVeh`,
                        name: "AverPrevLibVeh",
                        component: AverPrevLibVeh,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRobo/Reporte/RoboAverPrev`,
                        name: "RoboAverPrev",
                        component: RoboAverPrev,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRobo/Reporte/Documentos/`,
                        name: "documentosRobo",
                        component: Documentos,
                    },
                ]
            },
            {
                path: `${domain.domainName}/AsistenciaRLV/Reporte/`,
                name: "asistenciaRLV",
                component: AsistenciaRLV,
                children: [
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/ReporteDetalle`,
                        name: "ReporteDetalleRLV",
                        component: ReporteDetalleRLV,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia/`,
                        name: "AverPrevRLV1",
                        component: AverPrevRLV1,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia2/`,
                        name: "AverPrevRLV2",
                        component: AverPrevRLV2,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia3/`,
                        name: "AverPrevRLV3",
                        component: AverPrevRLV3,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia4/`,
                        name: "AverPrevRLV4",
                        component: AverPrevRLV4,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia5/`,
                        name: "AverPrevRLV5",
                        component: AverPrevRLV5,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/AverPrevia6`,
                        name: "AverPrevRLV6",
                        component: AverPrevRLV6,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRLV/Reporte/Documentos/`,
                        name: "documentosRLV",
                        component: Documentos,
                    },

                ]
            },
            {
                path: `${domain.domainName}/AsistenciaRCM/Reporte/`,
                name: "asistenciaRCM",
                component: AsistenciaRCM,
                children: [
                    {
                        path: `${domain.domainName}/AsistenciaRCM/Reporte/ReporteDetalle`,
                        name: "ReporteDetalleRCM",
                        component: ReporteDetalleRCM,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                    {
                        path: `${domain.domainName}/AsistenciaRCM/Reporte/Documentos/`,
                        name: "documentosRCM",
                        component: Documentos,
                    },
                ]
            },
            {
                path: `${domain.domainName}/perfilUsuario`,
                name: "perfilusuario",
                component: Perfil,
                beforeEnter: async (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global, 0, 0);
                }
            },
            {
                path: `${domain.domainName}/Configuracion`,
                name: "configuracion",
                component: Configuracion,
                beforeEnter: (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.single.configuracion, 0, 0);
                }
            },
            /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
            {
                path: `${domain.domainName}/BusquedaAvanzada`,
                name: "BusquedaAvanzada",
                component: BusquedaAvanzada,
                beforeEnter: async (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global, 0, 0);
                }
            },
            {
                path: `${domain.domainName}/BusquedaGeneral`,
                name: "busquedageneral",
                component: busquedageneral,
                beforeEnter: (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global);
                }
            },
            /* ------------------------------------------------------------------------*/
            {
                path: `${domain.domainName}/bitacora`,
                name: "bitacora",
                component: Bitacora,
                beforeEnter: (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global);
                }
            },
            {
                path: `${domain.domainName}/estadisticas/`,
                name: "estadisticas",
                component: Estadistica,
                beforeEnter: async (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global);
                }
            },
            {
                path: `${domain.domainName}/Viales`,
                name: "Viales",
                component: Viales,
                beforeEnter: async (to, from, next) => {
                    verficarPermiso(to, from, next, permisos.global);
                }
            },
            {
                path: `${domain.domainName}/AsistenciaVial/Reporte/`,
                name: "AsistenciaVial",
                component: AsistenciaVial,
                children: [
                    {
                        path: `${domain.domainName}/AsistenciaVial/Reporte/ReporteDetalle`,
                        name: "ReporteDetalleVial",
                        component: ReporteDetalleVial,
                        beforeEnter: async (to, from, next) => {
                            let datos = await MetodosGenrales.obtenerSessionReporte('reporte');
                            verficarPermiso(to, from, next, permisos.global, datos.nrreporte, datos.svindice);
                        }
                    },
                ]
            },
        ]
    },
    {
        path: `${domain.domainName}/noautorizado`,
        name: "noautorizado",
        component: NotAuthorized
    },
    {
        path: '*',
        name: "pagenotfound",
        component: PageNotFound
    },
    {
        path: `${domain.domainName}/Recuperar`,
        name: "Recuperar",
        component: Recuperar
    },
];


const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes
})

export default router;
import Security from "@/utils/security.vue";


router.beforeEach((to, from, next) => {
    if (to.name == "login") {
        next();
        return;
    }
    if (window.location.href.indexOf('login') == -1) {
        Security.checkSessionExpireRouter(next, Vue, Store, domain);
    } else {
        next();
    }
});


if (window.location.href.indexOf('login') == -1) {
    axios.defaults.baseURL = Store.state.domain.domainNameForApi;
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            let errorResponse = error.response;
            if (errorResponse.status === 401) {
                Security.mensajeDeExpirarSesion(Vue, Store);
                return [];
            }
            return Promise.reject(error);
        }
    );

}
